
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/introduction/support",
      function () {
        return require("private-next-pages/x/introduction/support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/introduction/support"])
      });
    }
  